import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderChernihiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernihiv/create-distribution-order-chernihiv",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderChernihiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernihiv/create-distribution-to-order-chernihiv",
      params,
      callBackFn
    );
  },
  async getChernihivAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-chernihiv/get-chernihiv-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
